<template>
  <div class="uk-grid" data-uk-grid>
    <div class="uk-width-auto">
      <button class="uk-button uk-button-primary uk-button-small" @click.prevent="openCreatePackageModal(null)">
        <span data-uk-icon="plus-circle"></span>
        Neues Paket erstellen
      </button>
    </div>
    <div class="uk-width-1-1" v-if="packages.length">
      <PackageTable :packages="packages" @openModal="onOpenModal" @deleted="onDeletePackage"></PackageTable>
    </div>
    <modal ref="modal" :options="{bgClose: false, escClose: false}" large>
      <div class="uk-modal-header">
        <div class="uk-h3">Paket erstellen</div>
      </div>
      <div class="uk-modal-body" uk-overflow-auto>
        <div class="uk-grid" data-uk-grid>
          <div class="uk-width-1-2@m">
            <label class="uk-form-label">Paketname</label>
            <input type="text" class="uk-input" v-model="form.name" />
          </div>
          <div class="uk-width-1-2@m">
            <label class="uk-form-label">VK-Preis Netto</label>
            <currency-input
              v-model="form.price"
              class="uk-input"
              :value-as-integer="true"
              :distraction-free="{
                hideCurrencySymbol: true
              }"
            ></currency-input>
          </div>
          <div class="uk-width-1-1">
            <div class="uk-h4 uk-margin-remove">Fahrzeuge wählen</div>
            <VehicleTable v-model="selected" :package-id="form.id"></VehicleTable>
          </div>
        </div>
      </div>
      <div class="uk-modal-footer uk-text-right">
        <button class="uk-button uk-button-text uk-modal-close" type="button" @click.prevent="cancelModal">
          Abbrechen
        </button>
        <button class="uk-button uk-button-primary uk-margin-small-left" type="button" @click.prevent="store">
          Speichern
        </button>
      </div>
    </modal>
  </div>
</template>
<script>
import PackageService from '@/services/package.service'
import VehicleTable from '@/components/admin/VehicleTable'
import PackageTable from '@/components/admin/PackageTable'
import Modal from '@/components/Modal'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      form: {
        id: null,
        name: '',
        price: 0
      },
      selected: [],
      packages: []
    }
  },
  components: { PackageTable, VehicleTable, Modal },
  mounted() {
    this.getPackages()
  },
  methods: {
    ...mapActions(['getMakes', 'getStats']),
    async getPackages() {
      const packages = await PackageService.getAll()
      this.packages = packages.data
    },
    openCreatePackageModal(pkg) {
      if (pkg) {
        this.form.id = pkg.id
        this.form.name = pkg.name
        this.form.price = pkg.price
        this.selected = pkg.vehicleIds
      } else {
        this.form = {
          id: null,
          name: '',
          price: 0
        }
        this.selected = []
      }
      this.$refs.modal.open()
    },
    onOpenModal(item) {
      this.openCreatePackageModal(item)
    },
    async store() {
      const payload = {
        id: this.form.id,
        name: this.form.name,
        price: this.form.price,
        vehicleIds: this.selected
      }
      try {
        await PackageService.store(payload)
        iziToast.success({
          title: 'OK',
          message: 'Das Paket wurde gespeichert!',
          timeout: 3000,
          position: 'topCenter'
        })
        this.getPackages()
        this.selected = []
        this.$refs.modal.close()
        this.getMakes()
        this.getStats()
      } catch (error) {
        console.log(error)
      }
    },
    cancelModal() {
      this.selected = []
      this.$router.replace({'query': null})
      this.$refs.modal.close()
    },
    onDeletePackage() {
      this.getPackages()
      this.getMakes()
      this.getStats()
    }
  }
}
</script>
